import React, { useRef, useState } from 'react';

import Card from '@material-ui/core/Card';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';

import { ClickHereToCopy } from './click-here-to-copy';
import Message from './legacy-message';

import { EMBEDDABLE_CAREERS_DOMAIN } from '../config/config';

type InputProps = {
  org: Org;
};

type EmbeddedDataTypes = 'orgKey' | 'accountId';

export const EmbeddableCareersPage = ({ org }: InputProps) => {
  const [selectedTab, setSelectedTab] = useState<EmbeddedDataTypes>('orgKey');
  const scriptCodeContainer = useRef<HTMLDivElement>(null);

  const orgKey = org.org_key;
  const { accountId, name } = org;

  const handleTabChange = (_event: React.ChangeEvent<{}>, value: EmbeddedDataTypes) => {
    setSelectedTab(value);
  };

  const handleRef = (node: HTMLDivElement) => {
    if (!node) {
      return;
    }
    // Weirdly we have to go around react to actually use a script
    // tag. If you just put it in the JSX it won't actually fetch the file
    const s = document.createElement('script');
    const d = document.createElement('div');
    s.type = 'text/javascript';
    s.setAttribute('src', `${EMBEDDABLE_CAREERS_DOMAIN}/bundle.js`);
    d.setAttribute('id', 'team-engine-careers-widget');
    if (selectedTab === 'orgKey') {
      d.setAttribute('data-orgKey', orgKey);
    } else {
      d.setAttribute('data-accountId', accountId.toString());
    }
    d.setAttribute('data-debug', 'true');
    if (node.hasChildNodes()) {
      node.replaceChildren(d, s);
    } else {
      node.appendChild(d);
      node.appendChild(s);
    }
  };

  return (
    <>
      <h3>Code</h3>
      <Card square>
        <Tabs value={selectedTab} onChange={handleTabChange}>
          <Tab label={`Jobs for ${name}`} value="orgKey" />
          <Tab label="Jobs for All Organizations" value="accountId" />
        </Tabs>
      </Card>
      {selectedTab === 'orgKey' && (
        <Message canBeDismissed={false}>
          <div
            ref={scriptCodeContainer}
          >{`<script type="text/javascript" src="${EMBEDDABLE_CAREERS_DOMAIN}/bundle.js"></script><div id="team-engine-careers-widget" data-orgKey="${orgKey}"></div>`}</div>
          <ClickHereToCopy refToTextToCopy={scriptCodeContainer} />
        </Message>
      )}
      {selectedTab === 'accountId' && (
        <Message canBeDismissed={false}>
          <div
            ref={scriptCodeContainer}
          >{`<script type="text/javascript" src="${EMBEDDABLE_CAREERS_DOMAIN}/bundle.js"></script><div id="team-engine-careers-widget" data-accountId="${accountId}"></div>`}</div>
          <ClickHereToCopy refToTextToCopy={scriptCodeContainer} />
        </Message>
      )}
      <h3>Preview</h3>
      {/* Minimum height is 200px which is roughly the size of a one row table to
      lessen the amount of flashing when swapping out account vs org tables */}
      <div className="u-maxHeight-400px u-minHeight-200px u-overflow-auto">
        <div ref={handleRef} />
      </div>
    </>
  );
};
